(function ($) {
    $(document).ready(function () {
        window.dataLayer = window.dataLayer || [];

        const formGtm = function () {
            $('form').on('submit', function () {
                const href = document.location.href.split('/');
                const partnerName = 2;

                window.dataLayer.push({
                    event: 'ga_event',
                    category: 'form submission',
                    action: 'Not yet recorded',
                    label: href[href.length - partnerName] + ' form'
                });
            });
        };
        formGtm();

    });
})(window.jQuery);
